import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'gait-capability-analysis-shared',
  templateUrl: 'gait-capability-analysis-shared.component.html',
  styleUrls: ['gait-capability-analysis-shared.component.scss']
})
export class GaitCapabilityAnalysisSharedComponent implements OnInit {
  initialized = false;


  constructor() { }

  ngOnInit(): void {
    this.initialized = true;
  }

}
